/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.auth

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.base.ui.composableWithStayTransitions

@Serializable
data object LandingRoute

fun NavController.navigateToLanding(navOptions: NavOptions? = null) {
    navigate(LandingRoute, navOptions)
}

fun NavGraphBuilder.landingDestination(
    onOtpSent: (email: String) -> Unit,
) {
    composableWithStayTransitions<LandingRoute> {
        LandingScreen(onOtpSent = onOtpSent)
    }
}
